import { useNavigate } from "react-router";
import FirebaseAuthService from "../../firebase-service/FirebaseAuthService";
import { FileComponent } from "../FileComponent/FileComponent";
import { useSelector } from "react-redux";

export const Navbar = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const formDataDic = useSelector((state) => state.formDataDic);
  const handleDeconnexion = () => {
    FirebaseAuthService.logoutUser()
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.log("cannot disconnect ", error);
      });
  };

  return (
    <div className="navbar  bg-neutral text-neutral-content justify-between">
      <div className="flex flex-col lg:flex-row">
        <div className="flex flex-row">
          <img
            alt="logo"
            src="/image/robot_front.png"
            className="w-[32px] lg:w-[42px] h-[32px] lg:h-[42px]"
          />
          <button
            className="btn btn-ghost text-sm lg:text-xl"
            onClick={() => {
              navigate("/home");
            }}
          >
            Ajiratomo
          </button>
        </div>
        {formDataDic?.isAllowed && <FileComponent />}
      </div>
      <div className="flex-row">
        <div className="dropdown dropdown-end">
          <div
            tabIndex={0}
            role="button"
            className="btn btn-ghost btn-circle avatar"
          >
            <div className="w-10 rounded-full">
              <img alt="utilisateur" src={user?.photoURL} />
            </div>
          </div>
          <ul
            tabIndex={0}
            className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li className="my-4">
              <a
                href="https://forms.gle/njPykRyxYyS5xyWw7"
                target="_blank"
                rel="noreferrer"
                className="btn btn-sm btn-neutral"
                onClick={() => {
                  handleDeconnexion();
                }}
              >
                Aide
              </a>
            </li>
            <li>
              <button
                className="btn btn-error btn-sm"
                onClick={() => {
                  handleDeconnexion();
                }}
              >
                Déconnexion
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
